<p-tabs
  styleClass="update-panel"
  [value]="activeIndex"
  (valueChange)="onTabChange($event)">
  <p-tablist>
    <p-tab [value]="0" class="pb-1">Notes</p-tab>
    <p-tab [value]="1" class="pb-1">Activity</p-tab>
    <p-tab [value]="2" class="pb-1">Pinned</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel [value]="0">
      <div class="mb-auto scrol-bx">
        <div *ngFor="let noteItem of workflowNotesList">
          <div class="update-txt globalborder-btm-header py-1">
            <div class="d-flex gap-2 align-items-start">
              <p-avatar
                *ngIf="getPhotoUrl(noteItem.userEmail) as photoUrl"
                [image]="photoUrl"
                shape="circle"
                size="normal"
                styleClass="flex-shrink-0 update-avatar-img" />
              <p-avatar
                *ngIf="!getPhotoUrl(noteItem.userEmail)"
                [label]="noteItem.createdBy | nameInitials"
                shape="circle"
                size="normal"
                styleClass="flex-shrink-0 update-avatar-initials" />
              <div class="flex-grow-1 min_width">
                <div
                  class="fonts-12 gap-1 d-flex justify-content-between align-items-center">
                  <label
                    class="update-author-name min_width fw-semibold text-truncate flex-grow-1"
                    pTooltip="{{ noteItem.createdBy }}"
                    tooltipPosition="top"
                    >{{ noteItem.createdBy }}</label
                  >
                  <div class="d-flex align-items-center gap-2 flex-shrink-0">
                    <label class="fw-light update-author-name">{{
                      noteItem.createdDate | date: "hh:mm a MMMM dd, yyyy"
                    }}</label>
                  </div>
                </div>
                <div
                  class="mt-1 d-flex justify-content-between align-items-start">
                  <div class="message-tooltip-anchor flex-grow-1 min_width">
                    <p
                      class="message mb-0"
                      [pTooltip]="getDisplayNote(noteItem.note)"
                      [innerHTML]="formatNote(noteItem.note)"
                      tooltipPosition="top"
                      [ngClass]="
                        hasLineBreak(noteItem.note)
                          ? 'note-message-multiline'
                          : 'text-truncate'
                      "></p>
                  </div>
                  <div class="mb-0 pb-0 d-flex justify-content-end pin-icon">
                    <label
                      class="custom-checkbox d-flex gap-1 align-items-end flex-shrink-0">
                      <p-checkBox
                        [inputId]="'notepin' + noteItem.recordId"
                        (onChange)="onNoteChecked($event, noteItem.recordId)"
                        [binary]="true"
                        [ngModel]="noteItem.pinned"
                        styleClass="custom-pin-checkbox">
                        <ng-template pTemplate="icon" let-checked="checked">
                          <span [ngClass]="checked ? 'fillsvg' : 'unfilledsvg'">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-pin-fill"
                              viewBox="0 0 16 16">
                              <path
                                d="M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A6 6 0 0 1 5 6.708V2.277a3 3 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354" />
                            </svg>
                          </span>
                        </ng-template>
                      </p-checkBox>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="workflowNotesList.length === 0">
          <p class="pt-2">No notes yet.</p>
        </div>
      </div>
      <div
        class="comment-box-container d-flex gap-2 justify-content-between align-items-stretch">
        <div class="form-group flex-grow-1 position-relative">
          <small *ngIf="noteError" class="text-danger note-error-msg"
            >Please enter a note before posting.</small
          >
          <textarea
            pTextarea
            cols="25"
            rows="1"
            placeholder="Post updates here"
            maxlength="1000"
            [(ngModel)]="note"
            (input)="noteError = false"></textarea>
        </div>
        <div class="text-end">
          <p-button
            label="Post"
            [disabled]="isDisableLink || isPosting"
            (click)="postWorkflowNote()" />
        </div>
      </div>
    </p-tabpanel>
    <p-tabpanel [value]="1">
      <div
        #updatesContainer
        class="mb-auto overflow-auto activity-pinned-container">
        <div *ngFor="let updates of workflowUpdatesList">
          <div class="update-txt globalborder-btm-header py-1">
            <div class="d-flex gap-2 align-items-start">
              <p-avatar
                *ngIf="getPhotoUrl(updates.userEmail) as photoUrl"
                [image]="photoUrl"
                shape="circle"
                size="normal"
                styleClass="flex-shrink-0 update-avatar-img" />
              <p-avatar
                *ngIf="!getPhotoUrl(updates.userEmail)"
                [label]="updates.createdBy | nameInitials"
                shape="circle"
                size="normal"
                styleClass="flex-shrink-0 update-avatar-initials" />
              <div class="flex-grow-1 min_width">
                <div
                  class="fonts-12 gap-1 d-flex justify-content-between align-items-center">
                  <label
                    class="update-author-name min_width fw-semibold text-truncate flex-grow-1"
                    pTooltip="{{ updates.createdBy }}"
                    tooltipPosition="top"
                    >{{ updates.createdBy }}</label
                  >
                  <div class="d-flex align-items-center gap-2 flex-shrink-0">
                    <label class="fw-light update-author-name">{{
                      updates.createdDate | date: "hh:mm a MMMM dd, yyyy"
                    }}</label>
                  </div>
                </div>
                <div
                  class="mt-1 d-flex justify-content-between align-items-start">
                  <p
                    class="message mb-0 flex-grow-1 text-truncate"
                    [innerHTML]="updates.message"
                    [pTooltip]="stripHtml(updates.message)"
                    tooltipPosition="top"></p>
                  <div class="mb-0 pb-0 d-flex justify-content-end pin-icon">
                    <!-- <input
                    pInputText
                    class="form-check-input"
                    (change)="onChecked($event, updates.recordId)"
                    [checked]="updates.pinned"
                    type="checkbox" /> -->
                    <label
                      class="custom-checkbox d-flex gap-1 align-items-end flex-shrink-0">
                      <p-checkBox
                        [inputId]="'pin' + updates.recordId"
                        (onChange)="onChecked($event, updates.recordId)"
                        [binary]="true"
                        [ngModel]="updates.pinned"
                        styleClass="custom-pin-checkbox">
                        <ng-template pTemplate="icon" let-checked="checked">
                          <span [ngClass]="checked ? 'fillsvg' : 'unfilledsvg'">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-pin-fill"
                              viewBox="0 0 16 16">
                              <path
                                d="M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A6 6 0 0 1 5 6.708V2.277a3 3 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354" />
                            </svg>
                          </span>
                        </ng-template>
                      </p-checkBox>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="workflowUpdatesList.length === 0">
          <p class="pt-2">No activity yet.</p>
        </div>
      </div>
    </p-tabpanel>
    <p-tabpanel [value]="2">
      <div class="mb-auto overflow-auto activity-pinned-container">
        <div *ngFor="let updates of workflowUpdatesPinnedList">
          <div class="update-txt globalborder-btm-header pt-1 pb-1">
            <div class="d-flex gap-2 align-items-start">
              <p-avatar
                *ngIf="getPhotoUrl(updates.userEmail) as photoUrl"
                [image]="photoUrl"
                shape="circle"
                size="normal"
                styleClass="flex-shrink-0 update-avatar-img" />
              <p-avatar
                *ngIf="!getPhotoUrl(updates.userEmail)"
                [label]="updates.createdBy | nameInitials"
                shape="circle"
                size="normal"
                styleClass="flex-shrink-0 update-avatar-initials" />
              <div class="flex-grow-1 min_width">
                <div
                  class="fonts-12 d-flex justify-content-between align-items-center">
                  <label
                    class="update-author-name min_width fw-semibold text-truncate flex-grow-1"
                    pTooltip="{{ updates.createdBy }}"
                    tooltipPosition="top"
                    >{{ updates.createdBy }}</label
                  >
                  <div class="d-flex align-items-center gap-2 flex-shrink-0">
                    <label class="fw-light update-author-name">{{
                      updates.createdDate | date: "hh:mm a MMMM dd, yyyy"
                    }}</label>
                  </div>
                </div>
                <div
                  class="mt-1 d-flex justify-content-between align-items-center">
                  <p
                    class="message mb-0 flex-grow-1 text-truncate"
                    [innerHTML]="updates.message"
                    [pTooltip]="stripHtml(updates.message)"
                    tooltipPosition="top"></p>
                  <div class="mb-0 pb-0 d-flex justify-content-end pin-icon">
                    <label class="custom-checkbox d-flex gap-1 align-items-end">
                      <p-checkBox
                        [inputId]="'pin' + updates.recordId"
                        (onChange)="onChecked($event, updates.recordId)"
                        [binary]="true"
                        [ngModel]="updates.pinned"
                        styleClass="custom-pin-checkbox">
                        <ng-template pTemplate="icon" let-checked="checked">
                          <span [ngClass]="checked ? 'fillsvg' : ''">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-pin-fill"
                              viewBox="0 0 16 16">
                              <path
                                d="M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A6 6 0 0 1 5 6.708V2.277a3 3 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354" />
                            </svg>
                          </span>
                        </ng-template>
                      </p-checkBox>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngFor="let noteItem of workflowNotesPinnedList">
          <div class="update-txt globalborder-btm-header pt-1 pb-1">
            <div class="d-flex gap-2 align-items-start">
              <p-avatar
                *ngIf="getPhotoUrl(noteItem.userEmail) as photoUrl"
                [image]="photoUrl"
                shape="circle"
                size="normal"
                styleClass="flex-shrink-0 update-avatar-img" />
              <p-avatar
                *ngIf="!getPhotoUrl(noteItem.userEmail)"
                [label]="noteItem.createdBy | nameInitials"
                shape="circle"
                size="normal"
                styleClass="flex-shrink-0 update-avatar-initials" />
              <div class="flex-grow-1 min_width">
                <div
                  class="fonts-12 d-flex justify-content-between align-items-center">
                  <label
                    class="update-author-name min_width fw-semibold text-truncate flex-grow-1"
                    pTooltip="{{ noteItem.createdBy }}"
                    tooltipPosition="top"
                    >{{ noteItem.createdBy }}</label
                  >
                  <div class="d-flex align-items-center gap-2 flex-shrink-0">
                    <label class="fw-light update-author-name">{{
                      noteItem.createdDate | date: "hh:mm a MMMM dd, yyyy"
                    }}</label>
                  </div>
                </div>
                <div
                  class="mt-1 d-flex justify-content-between align-items-start">
                  <div class="message-tooltip-anchor flex-grow-1 min_width">
                    <p
                      class="message mb-0"
                      [pTooltip]="getDisplayNote(noteItem.note)"
                      [innerHTML]="formatNote(noteItem.note)"
                      tooltipPosition="top"
                      [ngClass]="
                        hasLineBreak(noteItem.note)
                          ? 'note-message-multiline'
                          : 'text-truncate'
                      "></p>
                  </div>
                  <div class="mb-0 pb-0 d-flex justify-content-end pin-icon">
                    <label class="custom-checkbox d-flex gap-1 align-items-end">
                      <p-checkBox
                        [inputId]="'notepinp' + noteItem.recordId"
                        (onChange)="onNoteChecked($event, noteItem.recordId)"
                        [binary]="true"
                        [ngModel]="noteItem.pinned"
                        styleClass="custom-pin-checkbox">
                        <ng-template pTemplate="icon" let-checked="checked">
                          <span [ngClass]="checked ? 'fillsvg' : ''">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-pin-fill"
                              viewBox="0 0 16 16">
                              <path
                                d="M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A6 6 0 0 1 5 6.708V2.277a3 3 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354" />
                            </svg>
                          </span>
                        </ng-template>
                      </p-checkBox>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="
            workflowUpdatesPinnedList.length === 0 &&
            workflowNotesPinnedList.length === 0
          ">
          <p class="pt-2">Nothing pinned yet.</p>
        </div>
      </div>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
